import React from 'react';
import {Link} from 'react-router-dom';
import styles from './AppFooter.module.scss';

const LINKS = [
    {label: '使用条款', to: '/terms'},
    {label: '隐私保护', to: '/privacy'},
    {label: '安全指南', to: '/safety'},
    {label: '帮助支持', to: '/support'}
];

export default function AppFooter () {
    return (
        <footer className={styles.footer}>
            <div className={`cq-container ${styles.inner}`}>
                <div className={styles.brand}>CodeQuest</div>
                <nav className={styles.links}>
                    {LINKS.map(l => (
                        <Link key={l.to} to={l.to} className={styles.link}>{l.label}</Link>
                    ))}
                </nav>
                <div className={styles.copy}>© 2024 CodeQuest 编程探险</div>
            </div>
        </footer>
    );
}
